import { useUser } from '@privy-io/react-auth';

import { useWalletSecurityReady } from '@/features/wallet-access/use-wallet-security-ready';

import { useWalletMfaTotpManagement } from './use-wallet-mfa-totp-management';
import { WalletMfaMethod, type WalletTotpEnrollmentMaterial } from './wallet-mfa-types';

export type WalletMfaManagement = {
  ready: boolean;
  enabled: boolean;
  startEnrollment: () => Promise<WalletTotpEnrollmentMaterial>;
  submitEnrollment: (_code: string) => Promise<void>;
  remove: () => Promise<void>;
};

export const useWalletMfaManagement = (): WalletMfaManagement => {
  const ready = useWalletSecurityReady();
  const { user } = useUser();
  const { startTotpEnrollment, submitTotpEnrollment, removeTotp } = useWalletMfaTotpManagement();
  const methods = user?.mfaMethods ?? [];

  return {
    ready,
    enabled: methods.includes(WalletMfaMethod.Totp),
    startEnrollment: startTotpEnrollment,
    submitEnrollment: submitTotpEnrollment,
    remove: removeTotp,
  };
};
